import { apiRoutes } from '../../../../../constants/apiRoutes.ts';
import { AuctionListFilterParams } from '../../../../../constants/apiRoutes/auctionListQueryParams.ts';

export const usePrintUpcomingAuctionsReportPdf = (filterParams?: AuctionListFilterParams) => {
  const handleOpenPdf = async () => {
    const axios = window.getAxios();
    const paramsWithTitle = {
      ...filterParams,
      title: 'Upcoming Sales and Events'
    };
    const response = await axios.get(apiRoutes.auctions.getPdf.build(paramsWithTitle), {
      responseType: 'blob' // Important! Ensures response is a binary file
    });

    const blob = new Blob([response.data], { type: 'application/pdf' });
    const url = URL.createObjectURL(blob);

    // Open in a new tab
    window.open(url, '_blank');

    // Revoke object URL after some time to free memory
    setTimeout(() => URL.revokeObjectURL(url), 10000);
  };

  return handleOpenPdf;
};
